import {TranslationObject} from '@colonist/i18n'
import {BaseCardData, CardClickPopupType} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum} from '@colonist/game-states'

export class CardCommodityBack extends BaseCardData {
    cardEnum = CardEnum.CommodityBack
    cardTypeEnum = CardTypeEnum.Commodity
    isCardBack = true
    tipTitle: TranslationObject = {key: 'strings:game.cards.commodity.back.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.commodity.back.body'}
    clickPopupType = CardClickPopupType.None
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}

export class CardCommodityPaper extends BaseCardData {
    cardEnum = CardEnum.Paper
    cardTypeEnum = CardTypeEnum.Commodity
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.commodity.paper.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.commodity.paper.body'}
    clickPopupType = CardClickPopupType.TradeWindow
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}

export class CardCommodityCloth extends BaseCardData {
    cardEnum = CardEnum.Cloth
    cardTypeEnum = CardTypeEnum.Commodity
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.commodity.cloth.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.commodity.cloth.body'}
    clickPopupType = CardClickPopupType.TradeWindow
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}

export class CardCommodityCoin extends BaseCardData {
    cardEnum = CardEnum.Coin
    cardTypeEnum = CardTypeEnum.Commodity
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.commodity.coin.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.commodity.coin.body'}
    clickPopupType = CardClickPopupType.TradeWindow
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}
